export const MAX_UPLOAD_SIZE = 1024 * 1024 * 1024 * 5;

export const MIN_UPLOAD_WEIGHT = 0.08;
export const DEFAULT_UPLOAD_WEIGHT = 0.1;
export const MAX_UPLOAD_WEIGHT = 0.3;
export const UPLOAD_WEIGHT_LOG_FACTOR = 0.025;
export const ACCEPTED_EXTENSIONS = {
  "application/*": [
    ".doc",
    ".docx",
    ".docm",
    ".dot",
    ".dotm",
    ".dotx",
    ".odt",
    ".fodt",
    ".ott",
    ".rtf",
    ".wps",
    ".wpd",
    ".pages",
    ".abw",
    ".zabw",
    ".lwp",
    ".mw",
    ".mcw",
    ".hwp",
    ".sxw",
    ".stw",
    ".sgl",
    ".vor",
    ".602",
    ".bib",
    ".cwk",
    ".psw",
    ".uof",
    ".xls",
    ".xlsx",
    ".xlsm",
    ".xlsb",
    ".xlt",
    ".xltm",
    ".xltx",
    ".xlw",
    ".ods",
    ".fods",
    ".ots",
    ".numbers",
    ".123",
    ".wk1",
    ".wks",
    ".wb2",
    ".dbf",
    ".dif",
    ".slk",
    ".sxc",
    ".stc",
    ".uos",
    ".pxl",
    ".sdc",
    ".ppt",
    ".pptx",
    ".pptm",
    ".pot",
    ".potm",
    ".potx",
    ".pps",
    ".odp",
    ".fodp",
    ".otp",
    ".key",
    ".sxi",
    ".sti",
    ".uop",
    ".sdd",
    ".sdp",
    ".odg",
    ".fodg",
    ".otg",
    ".vsd",
    ".vsdx",
    ".vsdm",
    ".vdx",
    ".cdr",
    ".svm",
    ".std",
    ".sxd",
    ".pub",
    ".sda",
    ".eps",
    ".pdf",
    ".epub",
    ".pdb",
    ".ltx",
    ".smf",
    ".sxm",
    ".sxg",
    ".oth",
    ".odm",
    ".zip",
    ".eml",
    ".msg",
  ],
  "image/*": [
    ".jpg",
    ".jpeg",
    ".png",
    ".svg",
    ".bmp",
    ".gif",
    ".tif",
    ".tiff",
    ".pbm",
    ".pgm",
    ".ppm",
    ".xbm",
    ".xpm",
    ".pcx",
    ".pcd",
    ".pct",
    ".psd",
    ".tga",
    ".ras",
    ".pwp",
    ".wmf",
    ".emf",
    ".cgm",
    ".dxf",
    ".met",
    ".cmx",
    ".wpg",
  ],
  "text/*": [".txt", ".csv"],
};
export const BATCHED_UPLOAD_SIZE = 10;
